import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { CustomizationBase } from "./CustomizationBase";
import * as UTIL from "../../util";
export var Customization = function Customization(props) {
  var index = props.index,
      customObj = props.customObj,
      defaultOptionName = props.defaultOptionName,
      _props$mods = props.mods,
      mods = _props$mods === void 0 ? [] : _props$mods,
      setMods = props.setMods,
      _props$handleSidesPre = props.handleSidesPresent,
      handleSidesPresent = _props$handleSidesPre === void 0 ? function () {
    return '';
  } : _props$handleSidesPre,
      _props$option = props.option,
      option = _props$option === void 0 ? {
    options: []
  } : _props$option,
      _props$isEditMode = props.isEditMode,
      isEditMode = _props$isEditMode === void 0 ? false : _props$isEditMode,
      _props$editOptions = props.editOptions,
      editOptions = _props$editOptions === void 0 ? [] : _props$editOptions,
      parentOptions = props.parentOptions,
      addOn = props.addOn;
  var description = customObj.description,
      mandatory = customObj.mandatory,
      _customObj$productMod = customObj.productModifierOptions,
      productModifierOptions = _customObj$productMod === void 0 ? [] : _customObj$productMod,
      multiplesAllowed = customObj.supportsChoiceQuantities,
      productModifierOptionMetaDatas = customObj.productModifierOptionMetaDatas,
      optionGroupId = customObj.optionGroupId,
      chainId = customObj.chainId;
  var parentId = index;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hide = _useState2[0],
      setHide = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hideParent = _useState4[0],
      setHideParent = _useState4[1];

  var chainList; //chainList = mods.map(option => option.selectedOptions.map(childOption => childOption?.optionChainId)).flat()

  chainList = mods.map(function (option) {
    if (option.selectedOptions) {
      return option.selectedOptions.map(function (childOption) {
        return childOption === null || childOption === void 0 ? void 0 : childOption.optionChainId;
      });
    }

    return;
  }).filter(function (el) {
    return el !== null;
  }).flat();
  var inputType = mandatory ? "radio" : "checkbox";
  var optionGroup = {
    "optionGroupChainId": chainId,
    "optionGroupId": optionGroupId,
    "optionGroupName": description,
    "selectedOptions": []
  };
  useEffect(function () {
    var _option$options$;

    var includes = productModifierOptionMetaDatas.findIndex(function (metaData) {
      return metaData.metaKey === "hasNestedModifiers";
    });

    if (includes != -1) {
      var justSides = parentOptions.filter(function (el) {
        return el.description.toLowerCase().includes("side");
      });
      handleSidesPresent(true, productModifierOptions, {
        "optionGroupId": optionGroupId,
        "optionGroupChainId": chainId
      }, justSides);
      setHide(true);
    }

    if (Array.isArray(option === null || option === void 0 ? void 0 : option.options) && (option === null || option === void 0 ? void 0 : (_option$options$ = option.options[0]) === null || _option$options$ === void 0 ? void 0 : _option$options$.optionGroupId) === optionGroupId) {
      setHideParent(true);
    }
  }, []);

  var goToNext = function goToNext(elem, selector) {
    var sibling = document.getElementById(elem.id).nextSibling; // If there's no selector, return the first sibling

    if (!selector) {
      return sibling;
    } // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop


    while (sibling) {
      console.log('Matches?  ', sibling.matches(selector), sibling.className, selector);

      if ((" " + sibling.className + " ").replace(/[\n\t]/g, " ").indexOf(selector) > -1) {
        return sibling;
      }

      sibling = sibling.nextSibling; //return sibling;
    }
  };

  var handleCheckbox = function handleCheckbox(id, parent, cost, displayName) {
    var _mods$filter$;

    var newOptionGroup = _objectSpread(_objectSpread({}, optionGroup), {}, {
      selectedOptions: (_mods$filter$ = mods.filter(function (option) {
        return option.optionGroupId === optionGroupId;
      })[0]) === null || _mods$filter$ === void 0 ? void 0 : _mods$filter$.selectedOptions
    });

    var currentSelected = newOptionGroup.selectedOptions;
    var updatedSelected = UTIL.filterArrayRemove(currentSelected || [], UTIL.makeSelected(id, parent, cost, displayName), "optionId");
    newOptionGroup.selectedOptions = updatedSelected;
    return setMods(newOptionGroup);
  };

  var handleRadio = function handleRadio(id, parent, cost, displayName, elem) {
    var newOptionGroup = _objectSpread({}, optionGroup);

    var newSelected = [UTIL.makeSelected(id, parent, cost, displayName)];
    newOptionGroup.selectedOptions = newSelected;
    var mods = setMods(newOptionGroup);

    if (elem) {
      var target = elem.target;
      setTimeout(function () {
        if (target) {
          var _parent = target.closest(".cb-detail-section");

          if (_parent) {
            var nextSection = goToNext(_parent, "cb-detail-section");

            if (!nextSection) {
              _parent = target.closest(".cb-menu-detail__customization");

              if (_parent) {
                var _nextSection = goToNext(_parent, "cb-menu-detail__customization");

                return jumpToNextSection(_nextSection);
              }
            } else {
              return jumpToNextSection(nextSection);
            }
          }
        }
      }, 100);
    }

    return mods;
  };

  var jumpToNextSection = function jumpToNextSection(nextSection) {
    if (nextSection) {
      document.getElementById(nextSection.id).scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  var childOptions = customObj.productModifierOptions.map(function (option) {
    return Array.isArray(option.productModifierOptionsGroup) && option.productModifierOptionsGroup.map(function (newOption) {
      return _objectSpread(_objectSpread({}, newOption), {}, {
        parentChainId: option.chainId,
        parentOptionGroupId: option.optionGroupId
      });
    });
  });
  return !hide && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomizationOptions, {
    defaultOptionName: defaultOptionName,
    productModifierOptions: productModifierOptions,
    multiplesAllowed: multiplesAllowed,
    handleCheckbox: handleCheckbox,
    handleRadio: handleRadio,
    handleSidesPresent: handleSidesPresent,
    setMods: setMods,
    optionGroupId: optionGroupId,
    description: description,
    inputType: inputType,
    mandatory: mandatory,
    parentId: parentId,
    chainList: chainList,
    childOptions: childOptions,
    mods: mods,
    index: index,
    hideParent: hideParent,
    isEditMode: isEditMode,
    editOptions: editOptions,
    addOn: addOn
  }));
};
export var CustomizationOptions = function CustomizationOptions(props) {
  var defaultOptionName = props.defaultOptionName,
      _props$productModifie = props.productModifierOptions,
      productModifierOptions = _props$productModifie === void 0 ? [] : _props$productModifie,
      _props$multiplesAllow = props.multiplesAllowed,
      multiplesAllowed = _props$multiplesAllow === void 0 ? {} : _props$multiplesAllow,
      _props$handleCheckbox = props.handleCheckbox,
      handleCheckbox = _props$handleCheckbox === void 0 ? function () {
    return '';
  } : _props$handleCheckbox,
      _props$handleRadio = props.handleRadio,
      handleRadio = _props$handleRadio === void 0 ? function () {
    return '';
  } : _props$handleRadio,
      _props$handleSidesPre2 = props.handleSidesPresent,
      handleSidesPresent = _props$handleSidesPre2 === void 0 ? function () {
    return '';
  } : _props$handleSidesPre2,
      _props$setMods = props.setMods,
      _setMods = _props$setMods === void 0 ? function () {
    return '';
  } : _props$setMods,
      optionGroupId = props.optionGroupId,
      _props$description = props.description,
      description = _props$description === void 0 ? '' : _props$description,
      _props$inputType = props.inputType,
      inputType = _props$inputType === void 0 ? {} : _props$inputType,
      _props$mandatory = props.mandatory,
      mandatory = _props$mandatory === void 0 ? {} : _props$mandatory,
      _props$parentId = props.parentId,
      parentId = _props$parentId === void 0 ? {} : _props$parentId,
      _props$childOptions = props.childOptions,
      childOptions = _props$childOptions === void 0 ? [] : _props$childOptions,
      _props$chainList = props.chainList,
      chainList = _props$chainList === void 0 ? [] : _props$chainList,
      _props$mods2 = props.mods,
      mods = _props$mods2 === void 0 ? [] : _props$mods2,
      index = props.index,
      _props$hideParent = props.hideParent,
      hideParent = _props$hideParent === void 0 ? false : _props$hideParent,
      controlledValues = props.controlledValues,
      remaining = props.remaining,
      handleCounter = props.handleCounter,
      isEditMode = props.isEditMode,
      editOptions = props.editOptions,
      isSides = props.isSides,
      _props$addOn = props.addOn,
      addOn = _props$addOn === void 0 ? {} : _props$addOn;

  useEffect(function () {
    //Remove child options if parent is not selected
    if (!chainList.length) {
      return;
    }

    mods.forEach(function (mod) {
      childOptions.forEach(function (option) {
        if (option.length) {
          option.forEach(function (child) {
            if (child.optionGroupId === mod.optionGroupId) {
              if (!chainList.includes(child.parentChainId)) {
                _setMods(mod, true);
              }
            }
          });
        }
      });
    });
  }, [chainList]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideParent && /*#__PURE__*/React.createElement(CustomizationBase, {
    defaultOptionName: defaultOptionName,
    options: productModifierOptions,
    multiplesAllowed: multiplesAllowed,
    handleCheckbox: handleCheckbox,
    handleRadio: handleRadio,
    optionGroupId: optionGroupId,
    description: description,
    inputType: inputType,
    mandatory: mandatory,
    parentId: parentId,
    index: index,
    controlledValues: controlledValues,
    remaining: remaining,
    handleCounter: handleCounter,
    isSides: isSides,
    isEditMode: isEditMode,
    mods: mods
  }), childOptions.map(function (option, index) {
    return Array.isArray(option) && option.map(function (custom, childIndex) {
      return chainList.includes(custom.parentChainId) && /*#__PURE__*/React.createElement(Customization, {
        parentOptions: option,
        customObj: custom,
        key: "modification_".concat(custom.parentChainId, "-").concat(childIndex),
        mods: mods,
        index: index,
        setMods: function setMods(newUpdate) {
          return _setMods(newUpdate);
        },
        handleSidesPresent: handleSidesPresent,
        editOptions: editOptions,
        isEditMode: isEditMode
      });
    });
  }));
};